import { xlCol, xlColq } from "../../common/constants";
export const actionList = [{name:'Assign',id:0},{name:"Change",id:1},{name:"Cancel",id:2}]
export const tableHeaders = [
    { headerName: 'LR Number \nOffline LR No', field: 'lrNumber', xlCol: xlCol },
    { headerName: 'Receive Date\nChallan No.', field: 'receiveDate', xlCol: xlCol },
    { headerName: 'Source City\nSource Branch', field: 'sourceCityBranch', xlCol: xlCol },
    { headerName: 'Destination City\nDestination Branch', field: 'destinationCityBranch', xlCol: xlCol },
    { headerName: 'Payment Type\n LR Due Amt.', field: 'paymentTypeAmt', xlCol: xlCol },
    { headerName: `Total No of Units \nPayment Method`, field: 'totalNoOfUnits', xlCol: xlCol },
    { headerName: 'Freight \nDelivery Cartage', field: 'freight', xlCol: xlCol },
    { headerName: 'Receiver Name\nDelivery Hamali', field: 'receverName', xlCol: xlCol },
    { headerName: 'Receiver Number \nDelivery Op. Hamali', field: 'receiverNumber', xlCol: xlCol },
    { headerName: 'Assigned By User \nDemurrage Chg.', field: 'assignedBy', xlCol: xlCol },
    { headerName: 'Assigned Date \nDelivery Discount', field: 'assignedDate', xlCol: xlCol },
    { headerName: 'OFD Status \n Delivery GST', field: 'ofdStatus', xlCol: xlCol },
    { headerName: 'Total Outstanding', field: 'outDeliveryDate', xlCol: xlColq },
  ];

  export const tableHeadersfilter = [
    { headerName: '', field: 'LRNO', xlCol: xlCol },
    { headerName: '', field: 'ManualLRNo', xlCol: xlColq },
    { headerName: '', field: 'ReceiptDate', xlCol: xlCol },
    { headerName: '', field: 'ChallanNo', xlCol: xlCol },
    { headerName: '', field: 'BookingCity', xlCol: xlCol },
    { headerName: '', field: 'BookingBranch', xlCol: xlColq },
     { headerName: '', field: 'BookingCity', xlCol: xlCol },
    { headerName: '', field: 'DestinationCity', xlCol: xlColq },
    { headerName: '', field: 'DestinationBranch', xlCol: xlCol },
    { headerName: '', field: 'DueAmount', xlCol: xlCol },
  ];
  export const tablePending = [
    { headerName: 'LR Number', field: 'LRNO', xlCol: xlCol },
    { headerName: 'Offline LR No', field: 'ManualLRNo', xlCol: xlCol },
    { headerName: 'Payment Type', field: 'PaymentTypeName', xlCol: xlCol },
    { headerName: 'Source City', field: 'BookingCity', xlCol: xlCol },
    { headerName: 'Source Branch', field: 'BookingBranch', xlCol: xlCol },
    { headerName: 'Destination City', field: 'DestinationCity', xlCol: xlCol },
    { headerName: 'Destination Branch', field: 'DestinationBranch', xlCol: xlCol },
    { headerName: 'Receive Date', field: 'ReceiveDateTime', xlCol: xlCol },
    { headerName: `Units`, field: 'Units', xlCol: xlColq },
    { headerName: `LR Due Amt.`, field: 'DueAmount', xlCol: xlColq },
    { headerName: 'Receiver Name', field: 'RecName', xlCol: xlCol },
    { headerName: 'Receiver Number', field: 'RecMobileNo', xlCol: xlCol },
  ];
  export const tableStatus = [
    ...tablePending,
    { headerName: 'Delivery Assigned To User', field: 'AssignedUser', xlCol: xlCol },
    { headerName: 'Delivery Assigned Date', field: 'DeliveryAssignedDate', xlCol: xlCol },
    { headerName: 'Delivery Assigned By User', field: 'AssignedByUser', xlCol: xlCol },
    { headerName: 'Status', field: 'Status', xlCol: xlCol },
    { headerName: 'Download  POD', field: 'PODLink', xlCol: xlCol },
  ]
  